package com.mgacreative.hotel.feature.channelmanager.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.lazy.rememberLazyListState
import com.mgacreative.hotel.shared.ui.designsystem.components.*
import org.koin.compose.viewmodel.koinViewModel
import kotlinx.datetime.LocalDate
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AgencyAllotmentScreen(onNavigateBack: () -> Unit = {}) {
    val viewModel = koinViewModel<AgencyAllotmentViewModel>()
    val agencies by viewModel.agencies.collectAsState()
    val allotments by viewModel.allotments.collectAsState()
    val isLoading by viewModel.isLoading.collectAsState()
    val error by viewModel.errorMessage.collectAsState()

    val listState = rememberLazyListState()

    LaunchedEffect(Unit) {
        viewModel.refresh()
    }

    var selectedAgencyId by remember { mutableStateOf<String?>(null) }
    var roomCount by remember { mutableStateOf("0") }
    var showStartDatePicker by remember { mutableStateOf(false) }
    var showEndDatePicker by remember { mutableStateOf(false) }

    var startDate by remember { mutableStateOf("2026-07-21") }
    var endDate by remember { mutableStateOf("2026-07-25") }

    if (error != null) {
        AlertDialog(
            onDismissRequest = { viewModel.clearError() },
            title = { Text("Hata") },
            text = { Text(error!!) },
            confirmButton = {
                TextButton(onClick = { viewModel.clearError() }) { Text("Tamam") }
            }
        )
    }

    Scaffold(
        topBar = {
            HFTopBar(
                title = "Acente Kontenjan & Allotment",
                onNavigateBack = onNavigateBack
            )
        }
    ) { padding ->
        Column(modifier = Modifier.fillMaxSize().padding(padding)) {
            if (isLoading) {
                LinearProgressIndicator(modifier = Modifier.fillMaxWidth())
            }

        LazyColumn(
            state = listState,
            modifier = Modifier.fillMaxSize().verticalScrollbar(listState),
            contentPadding = PaddingValues(16.dp),
            verticalArrangement = Arrangement.spacedBy(24.dp)
        ) {
            item {
                HFCard(modifier = Modifier.fillMaxWidth()) {
                    Column(modifier = Modifier.padding(16.dp)) {
                        Text("Yeni Kontenjan Oluştur", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                        Spacer(Modifier.height(16.dp))

                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Text("Acenta Seçiniz:", modifier = Modifier.weight(1f))
                            Spacer(Modifier.width(8.dp))
                            if (agencies.isEmpty()) {
                                Text("Acenta bulunamadı.", color = Color.Gray)
                            } else {
                                var expanded by remember { mutableStateOf(false) }
                                Box {
                                    OutlinedButton(onClick = { expanded = true }) {
                                        Text(agencies.find { it.id == selectedAgencyId }?.name ?: "Seçiniz")
                                    }
                                    DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
                                        agencies.forEach { agency ->
                                            DropdownMenuItem(
                                                text = { Text(agency.name) },
                                                onClick = {
                                                    selectedAgencyId = agency.id
                                                    expanded = false
                                                }
                                            )
                                        }
                                    }
                                }
                            }
                        }

                        Spacer(Modifier.height(16.dp))

                        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            Text("Başlangıç:", modifier = Modifier.weight(0.5f))
                            OutlinedButton(onClick = { showStartDatePicker = true }, modifier = Modifier.weight(1f)) {
                                Text(startDate.toDisplayDate())
                            }
                        }
                        
                        Spacer(Modifier.height(8.dp))
                        
                        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            Text("Bitiş:", modifier = Modifier.weight(0.5f))
                            OutlinedButton(onClick = { showEndDatePicker = true }, modifier = Modifier.weight(1f)) {
                                Text(endDate.toDisplayDate())
                            }
                        }

                        if (showStartDatePicker) {
                            val initial = try { LocalDate.parse(startDate) } catch(e:Exception) { Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date }
                            VisualDatePicker(
                                initialDate = initial,
                                onDismissRequest = { showStartDatePicker = false },
                                onDateSelected = { 
                                    startDate = it.toString()
                                    showStartDatePicker = false 
                                }
                            )
                        }

                        if (showEndDatePicker) {
                            val initial = try { LocalDate.parse(endDate) } catch(e:Exception) { Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date }
                            VisualDatePicker(
                                initialDate = initial,
                                onDismissRequest = { showEndDatePicker = false },
                                onDateSelected = { 
                                    endDate = it.toString()
                                    showEndDatePicker = false 
                                }
                            )
                        }

                        Spacer(Modifier.height(16.dp))

                        HFTextField(
                            value = roomCount,
                            onValueChange = { roomCount = it },
                            label = "Oda Sayısı (Kontenjan)"
                        )

                        Spacer(Modifier.height(24.dp))

                        HFButton(
                            text = "Kontenjanı Kaydet",
                            modifier = Modifier.fillMaxWidth(),
                            onClick = {
                                val rooms = roomCount.toIntOrNull() ?: 0
                                if (selectedAgencyId != null && rooms > 0) {
                                    viewModel.createAllotment(selectedAgencyId!!, startDate, endDate, rooms)
                                }
                            }
                        )
                    }
                }
            }

            item {
                Text("Mevcut Kontenjanlar", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            }

            if (allotments.isEmpty()) {
                item {
                    Text("Henüz tanımlı kontenjan bulunmuyor.", color = Color.Gray)
                }
            } else {
                items(allotments) { allotment ->
                    val agencyName = agencies.find { it.id == allotment.agencyId }?.name ?: "Bilinmeyen Acenta"
                    HFCard(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier.padding(16.dp).fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column {
                                Text(agencyName, fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
                                Text("${allotment.startDate} - ${allotment.endDate}", style = MaterialTheme.typography.bodySmall)
                            }
                            Surface(
                                color = Color(0xFF4CAF50).copy(alpha = 0.2f),
                                shape = androidx.compose.foundation.shape.RoundedCornerShape(8.dp)
                            ) {
                                Text(
                                    text = "${allotment.allottedRooms} Oda",
                                    color = Color(0xFF4CAF50),
                                    fontWeight = FontWeight.Bold,
                                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp)
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}
}
